import Utils from './utils'
// let THREE = window.THREE
const trianglesToFaces = (triangles, node, materials, type) => {
  // type v   m     fuv       fn   vn
  const faces = []
  let count = 0
  let uvIndex = 0
  let nIndex = 0
  if (type === 'body') {
    for (let i = 0; i < triangles.length; i++) {
      if (i % 3 === 0) {
        faces.push(58)
        faces.push(triangles[i])
      } else if (i % 3 === 2) {
        faces.push(triangles[i])
        faces.push(
          materials.length - 1, // material_index
          uvIndex++, uvIndex++, uvIndex++, // face_vertex_uv
          count++, // face_normal
          nIndex++, nIndex++, nIndex++) // face_vertex_normal
        // break;
      } else {
        faces.push(triangles[i])
      }
    }
  } else {
    for (let i = 0; i < triangles.length; i++) {
      if (i % 3 === 0) {
        faces.push(58)
        faces.push(triangles[i])
      } else if (i % 3 === 2) {
        faces.push(triangles[i])
        faces.push(
          materials.length - 1, // material_index
          uvIndex, uvIndex, uvIndex++, // face_vertex_uv
          count++, // face_normal
          nIndex, nIndex, nIndex++) // face_vertex_normal
        // break;
      } else {
        faces.push(triangles[i])
      }
    }
  }

  return faces
}

const trianglesToFaces50 = (triangles, materials) => {
  // type v   m           fn   vn
  const faces = []
  let count = 0
  let nIndex = 0
  for (let i = 0; i < triangles.length; i++) {
    if (i % 3 === 0) {
      faces.push(50)
      faces.push(triangles[i])
    } else if (i % 3 === 2) {
      faces.push(triangles[i])
      faces.push(
        materials.length - 1, // material_index
        count++, // face_normal
        nIndex, nIndex, nIndex++) // face_vertex_normal
      // break;
    } else {
      faces.push(triangles[i])
    }
  }

  return faces
}

const gettextureData = (gacMaterial) => {
  const THREE = window.THREE
  if (!gacMaterial || !gacMaterial.isDiffuseTextureEnabled) {
    return
  }

  let textureOffset = gacMaterial.diffuseTexureOffset
  let textureScale = gacMaterial.diffuseTexureScale
  let textureRotation = gacMaterial.diffuseTexureRotation
  if (textureOffset === undefined || textureOffset === null) {
    textureOffset = [0.0, 0.0]
  }
  if (textureScale === undefined || textureScale === null) {
    textureScale = [1.0, 1.0]
  }
  if (textureRotation === undefined || textureRotation === null) {
    textureRotation = 0.0
  }
  return {
    uuid: Utils.genUuid(),
    mapping: 300,
    repeat: [1, 1],
    offset: textureOffset,
    center: [0, 0],
    rotation: textureRotation,
    scale: textureScale,
    wrap: [THREE.RepeatWrapping, THREE.RepeatWrapping], // 支持平铺
    minFilter: 1008,
    magFilter: 1006,
    anisotropy: 1,
    flipY: true,
    image: gacMaterial.diffuseTexureFilePath
  }
}

const setMaterialData = async (node, gacMaterials, json) => {
  const materialUuid = node.materialId ? node.materialId : Utils.genUuid()
  const gacMaterial = gacMaterials.find((x) => x.id === materialUuid)

  if (!gacMaterial) {
    return {
      uuid: materialUuid,
      type: 'MeshPhongMaterial',
      color: node.color ? Utils.rgbaToHex(...node.color) : undefined
    }
  }
  const textureData = gettextureData(gacMaterial)

  let shininess = gacMaterial.shininess || 0.0

  if (shininess === 0.0) {
    gacMaterial.specular = [0, 0, 0, 255]
    shininess = 1
  }

  const material = {
    uuid: materialUuid,
    // "type":"MeshBasicMaterial",
    type: 'MeshPhongMaterial',
    ambient: Utils.rgbaToHex(...gacMaterial.ambient),
    // color:Utils.rgbaToHex(...gacMaterial.diffuse),  // 材质颜色
    color: Utils.rgbaToHex(...node.color), // 材质颜色
    specular: Utils.rgbaToHex(...gacMaterial.specular), // 材质的镜面反射色
    shininess: shininess, // 指定高光部分的亮度
    // side: THREE.DoubleSide,

    // "emissive":0,  
    // "transparent":false,
    // "wireframe":false,  //将几何图形渲染为线框。 默认值为 false
  }

  if (gacMaterial.transparency !== 1.0) { // 材质透明度
    material.opacity = gacMaterial.transparency // 透明度设置，0 表示完全透明，1 表示完全不透明
    material.transparent = true // 是否开启透明，默认 false
  }

  if (textureData) {
    material.map = textureData.uuid
    json.textures.push(textureData)
    if (!json.images.find((x) => x.uuid === textureData.image)) {
      const imageData = await Utils.decodeImage(`${process.env.VUE_APP_STATIC_HOST}/textures/${gacMaterial.diffuseTexureFilePath}`)
      const base64 = await Utils.blobToDataURL(new Blob([imageData.target], { type: 'image/png' }))
      json.images.push({
        uuid: textureData.image,
        // "url":  "https://threejs.org/examples/textures/uv_grid_opengl.jpg"// "http://shop-console-local.goujianwu.com/e.png" //base64
        url: base64
      })
    }
  }

  return material
}

const getGeometry = (node, materials) => {
  const geometryUuid = Utils.genUuid()
  const faces = trianglesToFaces(node.mesh.triangles, node, materials, node.type)
  return {
    version: 4,
    uuid: geometryUuid,
    type: 'Geometry',
    data: {
      faces: faces,
      vertices: node.mesh.vertices,
      normals: node.mesh.normals,
      uvs: [node.mesh.uvs],
      colors: [1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1],
    }

  }
}

const childrenNodeToMesh = async (node, gacMaterials, json, matrix) => {
  const materialData = await setMaterialData(node, gacMaterials, json)
  if (!json.materials.find((m) => m.uuid === materialData.uuid)) {
    json.materials.push(materialData)
  }

  // geometries
  const geometry = getGeometry(node, json.materials)
  json.geometries.push(geometry)

  const firstLevelChildren = {
    uuid: Utils.genUuid(), type: 'Mesh', name: 'mesh', matrix, geometry: geometry.uuid
  }

  if (materialData) {
    firstLevelChildren.material = materialData.uuid
  }
  return firstLevelChildren
}

const convertGacJsonToThressJson = async (gacJson, showDimension) => {
  const matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
  const json = {
    metadata: {
      version: 4.4,
      type: 'Object',
      generator: 'GJW'
    },
    object: {
      uuid: Utils.genUuid(),
      type: 'Object',
      name: '',
      matrix,
      children: []
    },
    geometries: [],
    materials: [],
    textures: [],
    images: []
  }
  const nodes = gacJson.nodes
  const gacMaterials = gacJson.materials
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]
    if (node.type === 'body' || node.type === 'face') {
      const firstLevelChildren = await childrenNodeToMesh(node, gacMaterials, json, matrix)
      firstLevelChildren.children = []
      json.object.children.push(firstLevelChildren)
      if (node.children) {
        node.children.forEach(() => {

          // if(c.type == "body" || c.type == "face"){
          //     let secondLevelChildren =  childrenNodeToMesh(c,gacMaterials,json,matrix)
          //     secondLevelChildren.material = firstLevelChildren.material
          //     json.object.children.push(secondLevelChildren)
          //     firstLevelChildren.children.push(firstLevelChildren)
          // }
        })
      }
    } else if (node.type === 'dimension' && node.children && showDimension) {
      node.children.forEach((cc) => {
        if (cc.type === 'text') {
          const meshJson = cc.mesh
          const materialUuid = Utils.genUuid()
          const color = [255, 1, 255]

          const materialData = {
            uuid: materialUuid,
            type: 'MeshPhongMaterial',
            color: Utils.rgbaToHex(...color)
          }
          json.materials.push(materialData)

          // geometries
          const faces = trianglesToFaces50(meshJson.triangles, json.materials)
          const geometry = {
            version: 4,
            uuid: Utils.genUuid(),
            type: 'Geometry',
            data: {
              faces: faces,
              vertices: meshJson.vertices,
              normals: meshJson.normals,
              uvs: [meshJson.uvs],
              colors: [1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1],
            }

          }
          json.geometries.push(geometry)

          const firstLevelChildren = {
            uuid: Utils.genUuid(), type: 'Mesh', name: 'mesh', matrix, geometry: geometry.uuid, children: []
          }
          firstLevelChildren.material = materialData.uuid

          json.object.children.push(firstLevelChildren)
        }
      })
    } else if (node.type === 'group') {
      await handleGroupNode(node, gacMaterials, json, matrix)
    }
  }
  return json
}

const handleGroupNode = async (node, gacMaterials, json, matrix) => {
  const childrenLength = node.children.length
  for (let nci = 0; nci < childrenLength; nci++) {
    const c = node.children[nci]
    if (c.type === 'body' || c.type === 'face') {
      const firstLevelChildren = await childrenNodeToMesh(c, gacMaterials, json, matrix)
      firstLevelChildren.children = []
      json.object.children.push(firstLevelChildren)
    } else if (c.type === 'group') {
      await handleGroupNode(c, gacMaterials, json, matrix)
    }
  }
}

const convertMeshJsonToThressJson = (meshJson, color) => {
  const matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
  const json = {
    metadata: {
      version: 4.4,
      type: 'Object',
      generator: 'GJW'
    },
    object: {
      uuid: Utils.genUuid(),
      type: 'Object',
      name: '',
      matrix,
      children: []
    },
    geometries: [],
    materials: [],
    textures: [],
    images: []
  }
  const materials = []

  const materialUuid = Utils.genUuid()
  if (!color) {
    color = [255, 1, 255]
  }

  const materialData = {
    uuid: materialUuid,
    type: 'MeshPhongMaterial',
    color: Utils.rgbaToHex(...color)
  }
  json.materials.push(materialData)

  materials.push(materialData)

  // geometries
  const faces = trianglesToFaces50(meshJson.triangles, materials)
  const geometry = {
    version: 4,
    uuid: Utils.genUuid(),
    type: 'Geometry',
    data: {
      faces: faces,
      vertices: meshJson.vertices,
      normals: meshJson.normals,
      uvs: [meshJson.uvs],
      colors: [1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1],
    }

  }
  json.geometries.push(geometry)

  const firstLevelChildren = {
    uuid: Utils.genUuid(), type: 'Mesh', name: 'mesh', matrix, geometry: geometry.uuid
  }

  if (materialData) {
    firstLevelChildren.material = materialData.uuid
  }

  firstLevelChildren.children = []
  json.object.children.push(firstLevelChildren)
  return json
}
export default { convertGacJsonToThressJson, convertMeshJsonToThressJson }
